<template>
  <v-navigation-drawer v-model="drawerCarrinho" location="right" temporary class="cart-drawer" v-on:update:modelValue="recolher">
    <div class="cart-top">
      <v-row>
        <v-col cols="6" class="mt-3 pa-4">
          <v-btn variant="outlined" rounded="xl" class="text-color-0" @click="recolher">
            <template v-slot:append>
              <v-icon icon="mdi-chevron-right" class="text-color-2"></v-icon>
            </template>
            RECOLHER
          </v-btn>
        </v-col>
        <v-col cols="6" class="mt-3 d-flex align-center justify-end px-5">
          <v-btn variant="text" rounded="xl" class="text-color-0" @click="limparCarrinho()" v-if="getTotalValueCart > 0">
            Limpar Carrinho
          </v-btn>
        </v-col>
        <v-col cols="12" class="pa-0">
          <hr class="fine-line">
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col v-if="getSelectedAddress.destiny_type >= 1 && getSelectedAddress.area == null" cols="12" class="text-color-red text-small">
          <v-alert variant="tonal" class="alert-custom-red d-flex align-center justify-space-between pa-2">
            <v-row no-gutters>
              <v-col cols="1"><v-icon icon="mdi-alert-outline" class="text-color-red" size="x-large"></v-icon></v-col>
              <v-col cols="11" class="ps-2">
                <span>
                  Infelizmente não efetuamos entrega para este endereço. 
                  Por favor, verifique se o endereço está
                </span>
                <span v-if="getConfig.storeConfig.min_withdrawal_value_order >= 0">
                  correto ou retire suas compras em nossa unidade.
                </span>
                <span v-else>correto.</span>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
        <v-col v-else-if="getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order < 0" cols="12" class="text-small text-color-red">
          <v-alert variant="tonal" class="alert-custom-red d-flex align-center justify-space-between pa-2">
            <v-row no-gutters>
              <v-col cols="1"><v-icon icon="mdi-alert-outline" class="text-color-red" size="x-large"></v-icon></v-col>
              <v-col cols="11" class="ps-2">
                <span>
                  Infelizmente não efetuamos retirada nesta unidade. 
                  Por favor, altere para um endereço de entrega.
                </span>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
        <v-col v-else cols="12" class="text-color-0 d-flex align-center justify-space-between text-small px-5 pt-5" :class="mobile == true ? 'text-small': ''">
          <Svgs :icon="'caminhao'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
          <span class="ms-1 text-end" v-if="valorMinimo > 0 && parseFloat(getTotalValueCart) < valorMinimo">Faltam <b class="text-color-1">{{ parseFloat(getTotalValueCart) > valorMinimo ? "R$ 0,00" : $formatNumber(valorMinimo - getTotalValueCart, {style: 'currency', currency: 'BRL'}) }}</b> para o pedido mínimo de <b class="text-color-1">{{ $formatNumber(valorMinimo, {style: 'currency', currency: 'BRL'}) }}</b></span>
          <span class="ms-1 text-end" v-else-if="valorMinimo > 0 && parseFloat(getTotalValueCart) >= valorMinimo">Parabéns! Você atingiu o valor mínimo de <b class="text-color-1">{{ $formatNumber(valorMinimo, {style: 'currency', currency: 'BRL'}) }}</b></span>
          <span class="ms-1 text-end" v-else-if="valorMinimo == 0 && parseFloat(getTotalValueCart) > 0">Parabéns! Clique abaixo para finalizar o pedido.</span>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12" class="px-5" v-if="valorMinimo == 0 && parseFloat(getTotalValueCart) == 0">
          <v-progress-linear :model-value="0" :max="1" striped class="text-color-0 rounded" height="6"></v-progress-linear>
        </v-col>
        <v-col cols="12" class="px-5" v-else-if="valorMinimo == 0 && parseFloat(getTotalValueCart) > 0">
          <v-progress-linear :model-value="1" :max="1" striped class="text-color-1 rounded" height="6"></v-progress-linear>
        </v-col>
        <v-col cols="12" class="px-5" v-else>
          <v-progress-linear :model-value="getTotalValueCart" :max="valorMinimo" striped class="text-color-1 rounded" height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col class="v-col-6 text-start text-color-black text-nowrap px-5 pb-5 text-small">
          <div v-if="getTotalCashback > 0">
          Ganhe <b>{{ $formatNumber(getTotalCashback, {style: 'currency', currency: 'BRL'}) }}</b> de Cashback. 
          <sup>
            <v-tooltip text="Após todas as etapas do pedido concluído você irá receber de volta o valor de Cashback na sua Carteira Digital. Você poderá utilizá-lo na próxima compra.">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" icon="mdi-information-outline" size="small"></v-icon>
              </template>
            </v-tooltip>
          </sup> 
          </div>
        </v-col>
        <v-col class="v-col-6 text-end text-color-1" :class="mobile == true ? 'text-small': ''">
          Sub-total: <b>{{ $formatNumber(getTotalValueCart, {style: 'currency', currency: 'BRL'}) }}</b>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12">
          <v-btn variant="flat" :disabled="parseFloat(getTotalValueCart) < valorMinimo || parseFloat(getTotalValueCart) == 0" block size="x-large" :class="parseFloat(getTotalValueCart) < valorMinimo || parseFloat(getTotalValueCart) == 0 ? 'bg-color-0' : 'bg-color-2'" class="text-color-white text-medium font-weight-bold" @click="finalizar()">FINALIZAR PEDIDO</v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="cart-bottom">
      <v-row class="px-0 mx-0 my-0 overflow-y-auto" v-scroll:#scroll-target="onScroll" v-if="loadingCart == false && getTotalCart > 0">
        <v-col class="pa-0 d-flex align-center justify-center flex-wrap text-center">
          <v-list class="w-100 pa-0 ma-0 br-0" v-for="m in getItensCart" :key="m.catid">
            <v-list-item class="bg-color-gray text-color-0 text-start text-small py-0">{{ getCategoryById(m.catid) != undefined ? getCategoryById(m.catid).name : '' }} ({{ m.qtd }} {{ m.qtd > 1 ? ' itens':' item' }}) - {{ $formatNumber(m.total, {style: 'currency', currency: 'BRL'}) }}</v-list-item>
            <ProductList v-for="p in m.itens" :key="p.sku" :product="p"></ProductList>
          </v-list>
        </v-col>
      </v-row>
      <v-row class="px-4 ma-0 no-itens" v-else>
        <v-col class="pa-0 d-flex align-center justify-center flex-wrap text-center">
          <div>
            <Svgs :icon="'carrinho'" :color="'fill-color-gray'" :width="130" :height="130"></Svgs>
            <h3 class="text-color-0 w-100 mt-3">NÃO HÁ PRODUTOS NO CARRINHO.</h3>
            <span class="text-color-0 w-100 mt-1"> Nosso Supermercado é super seguro e<br>realizar o pedido é super fácil. Experimente =)</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-navigation-drawer>
</template>

<script>
import Svgs from '@/components/Svgs.vue';
import ProductList from '@/components/ProductList.vue';
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
  name: 'Cart',
  components: {
    Svgs,
    ProductList
  },
  data(){
    return {
      offsetTop: 0,
      drawerCarrinho: false,
      valorMinimo: 0,
      mobile: false,
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    recolher: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapGetters('cart', {
      getItensCart: 'getItensCart',
      getTotalCart: 'getTotalCart',
      getTotalValueCart: 'getTotalValueCart',
      getTotalCashback: 'getTotalCashback'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig',
      getCategoryById: 'getCategoryById'
    }),
    ...mapState('cart', {
      loadingCart: 'loadingCart'
    }),
    ...mapGetters('user', {
      getSelectedAddress: 'getSelectedAddress',
    }),
  },
  watch: {
    drawer() {
      this.drawerCarrinho = this.drawer;
      var root = document.getElementsByTagName( 'html' )[0];
      if(this.drawerCarrinho == true){
        if(this.getSelectedAddress.destiny_type == 2){
          this.valorMinimo = this.getConfig.storeConfig.min_express_value_order;
        } else if(this.getSelectedAddress.destiny_type == 1){
          this.valorMinimo = this.getConfig.storeConfig.min_delivery_value_order;
        } else {
          this.valorMinimo = this.getConfig.storeConfig.min_withdrawal_value_order;
        }
        root.style.overflow = "hidden";
      } else {
        root.style.overflow = "auto";
      }
    },
    'getSelectedAddress': function (){
        if(this.getSelectedAddress.destiny_type == 2){
          this.valorMinimo = this.getConfig.storeConfig.min_express_value_order;
        } else if(this.getSelectedAddress.destiny_type == 1){
          this.valorMinimo = this.getConfig.storeConfig.min_delivery_value_order;
        } else {
          this.valorMinimo = this.getConfig.storeConfig.min_withdrawal_value_order;
        }
    },
  },
  methods: {
    ...mapActions('cart', {
      clearCart: 'clearCart'
    }),
    checkLayout(){
      var val = window.innerWidth;
      if (parseFloat(val) >= 1280) {
          this.mobile = false;
      } else {
          this.mobile = true;
      }
    },
    actionLimparCarrinho: function(r){
      if(r){
        this.clearCart();
      }
    },
    limparCarrinho(){
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja limpar o carrinho de compras?", response: this.actionLimparCarrinho });
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    finalizar(){
      if(this.getConfig.isu > 0){
        this.$router.push('/checkout');
      } else {
        this.emitter.emit('dialogLogin');
        this.recolher();
      }
    },
    keyDownHandler: function(event) {
      if (event.code === 'Escape') {
        this.recolher();
      }
    }
  },
  mounted(){
    this.checkLayout();
    window.addEventListener("resize", this.checkLayout);
    window.addEventListener('keydown', this.keyDownHandler);
  },
  unmounted(){
    window.removeEventListener("resize", this.checkLayout);
    window.removeEventListener('keydown', this.keyDownHandler);
  }
}
</script>